<footer>
    <span *ngIf="applicationInfo.labAddress && applicationInfo.labAddress !== ''">Address: {{applicationInfo.labAddress}}</span>
    <span *ngIf="applicationInfo.labPhone && applicationInfo.labPhone !== ''"> | Phone: {{applicationInfo.labPhone}}</span>  <br/>
    <span *ngIf="applicationInfo.email && applicationInfo.email !== ''"> | Email: {{applicationInfo.email}}</span>  <br/>
    Copyright © 2012-{{Year}}.
    <br/>
    All trademarks or registered trademarks are property of their respective owners. <br/>
</footer>
